<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="closeModal">AdTag Group Link</modal-header>
        </div>
        <p>Your request to create an AdTag Group has been submitted. You can check the progress of the tag creation <a href="/tags" target="_blank">here</a>.</p>
        <p>The link to view the group is already available below. Click the copy icon to copy it to your clipboard</p>
        <div class="btn-group">
          <a @click="copyToClipboard" :class="isCopiedClass"><i class="fa fa-copy"></i></a>
          <a :href="tagUrl" class="btn btn-secondary" target="_blank">{{ tagUrl }}</a>
        </div>
        <div v-if="isCopied" class="alert alert-success" role="alert" id="copiedAlert">
          <p>Url has been copied to clipboard!</p>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="closeModal" cancelText="Close" hideConfirmText />
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

// import { url } from '@/config'

export default {
  name: 'modal_adtag_link',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String
  },
  data: () => ({
    isCopied: false
  }),
  mounted () {
    this.isCopied = false
  },
  computed: {
    isCopiedClass () {
      if (this.isCopied) {
        return 'btn btn-success'
      } else {
        return 'btn btn-primary'
      }
    },
    tagUrl () {
      return this.confirmId
    }
  },
  methods: {
    copyToClipboard () {
      const el = document.createElement('textarea')
      el.value = this.tagUrl
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.isCopied = true
      if (selected) {
        document.getSelection().removeAllRanges()
        document.getSelection().addRange(selected)
      }
    },
    closeModal () {
      this.isCopied = false
      this.close()
    }
  }
}

</script>

<style lang="scss">
  #copiedAlert {
    margin-top:15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-adtag-link.vue